import {isNumber, map, sumBy} from 'lodash';
import {useCallback, useMemo} from 'react';
import {
    PieChart as RechartsPieChart, Pie, Cell, ResponsiveContainer, TooltipProps, CellProps, Tooltip, Label, Sector,
} from 'recharts';

const ACTIVE_SHAPE_ZOOM = 1.05;

type Props = {
    data: any[];
    dataKey?: string;
    minWidth?: number;
    cells?: CellProps[];
    noDataCell?: CellProps;
    innerLabel?: string | number;
    innerLabelClass?: string;
    tooltip?: TooltipProps;
    innerRadius?: number;
    outerRadius?: number;
    activeIndex?: number | number[];
};

export const PieChart: React.FC<Props> = ({
    data, dataKey = 'value', tooltip, cells, noDataCell, innerLabel, innerLabelClass, minWidth = 250, ...rest
}: Props) => {
    const noData = useMemo(() => !sumBy(data, dataKey), [data, dataKey]);

    const renderActiveShape = useCallback((props) => {
        const activeProps = {...props, ...(!noData && {outerRadius: props.outerRadius * ACTIVE_SHAPE_ZOOM})};
        return <Sector {...activeProps} />;
    }, [noData]);

    return (
        <ResponsiveContainer minWidth={minWidth}>
            <RechartsPieChart width={400} height={400}>
                <Pie
                    activeShape={renderActiveShape}
                    data={noData && noDataCell ? [{name: null, value: 1}] : data}
                    cx='50%'
                    cy='50%'
                    dataKey={dataKey}
                    {...rest}
                >
                    {(innerLabel || isNumber(innerLabel)) && <Label className={innerLabelClass} position='center' value={innerLabel} />}
                    {tooltip && <Tooltip {...tooltip} />}
                    {noData && noDataCell ?
                        <Cell {...noDataCell} name={null} /> :
                        map(cells, (cell, i) => <Cell key={`cell-${i}`} {...cell} />)}
                </Pie>
            </RechartsPieChart>
        </ResponsiveContainer>
    );
};